// Helper to return a counter that increments when called
export const counter = i => () => ++i; // eslint-disable-line

export const isSizeEnabled = (enabled, size) =>
  (enabled || ['mobile', 'tablet', 'desktop']).includes(size);

export const hasVideo = ({ items, data }) => {
  if (data && data.coverMedia && data.coverMedia.type === 'video') {
    return true;
  }
  return !!items.find(i => {
    if (i.type === 'video') {
      return true;
    }
    if (i.type === 'thirdParty' && i.data.provider === 'youtube') {
      return true;
    }
    if (i.type === 'thirdParty' && i.data.provider === 'vimeo') {
      return true;
    }
    return false;
  });
};
